module.exports = __webpack_public_path__ + "img/insigne_logo_login.78de448d.png";